export default __webpack_public_path__ + "images/4a9420ffb0df4cd8b88f54ce931356af-check.svg";